"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPreview = void 0;
const isPreview = ({ query }) => Boolean(query?.token) &&
    Boolean(query?.['server-id']) &&
    Boolean(query?.locale);
exports.isPreview = isPreview;
